import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DateTimeControl } from '../../../form-models/datetime-control';

@Component({
  selector: 'hb-df-date-time',
  templateUrl: './dynamic-date-time.component.html',
})
export class DynamicDateTimeComponent {
  @Input() public control: DateTimeControl;
  @Input() public formGroup: FormGroup;

  @Output() public onOverrideValue = new EventEmitter();

  public overrideValue() {
    this.onOverrideValue.emit();
  }
}
